import slice from "./backdropSlice";

export default slice.reducer;
